import { render, staticRenderFns } from "./Title.vue?vue&type=template&id=57765fd4&scoped=true&"
var script = {}
import style0 from "./Title.vue?vue&type=style&index=0&id=57765fd4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57765fd4",
  null
  
)

export default component.exports